import { APIGet, APIPut, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { ICheckIns, INotification } from "../customer/teesheet";

const apiVersion = "2024-04";
const baseGuestUrl = "/" + apiVersion + "/guest/tee-sheet";

interface IGetNotifications {
  date?: string;
  short_name?: string;
  facility_id?: number;
  start_date?: string;
  end_date?: string;
}

interface IGetEvents {
  short_name?: string;
  facility_id?: number;
  start_date?: string;
  end_date?: string;
}

interface IGetCheckInsParams {
  facility_id: number;
  day_of_week_number: number;
  date?: string;
  tee_time_date?: string;
}

export async function GetGuestNotifications(
  params: IGetNotifications,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<Array<INotification>>> {
  return await APIGet(baseGuestUrl + "/notification", params, useGlobalLoader, cancelToken);
}

export async function GetGuestCheckIns(
  params: IGetCheckInsParams,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<Array<ICheckIns>>> {
  return await APIGet(baseGuestUrl + "/check-in", params, useGlobalLoader, cancelToken);
}

export async function PutCancelWaitTime(
  params: { waitlist_id: string; customer_email?: string; phone_digits?: string },
  useGlobalLoader: boolean,
) {
  return await APIPut(baseGuestUrl + "/waitlist/cancel", params, useGlobalLoader);
}

export async function PutBookingReminderAction(
  params: { token: string; action: string },
  useGlobalLoader: boolean,
) {
  return await APIPut(baseGuestUrl + "/booking-reminder", params, useGlobalLoader);
}

export async function GetGuestEvents(params: IGetEvents, useGlobalLoader: boolean) {
  return await APIGet(baseGuestUrl + "/event", params, useGlobalLoader);
}
